import { createContext } from 'react';
export const DiagnosisContext = createContext({});
